import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./DiscardChangesModal.css";

/**
 * Shared confirmation modal for discarding unsaved changes before navigating
 * away. Copy is parameterized so each feature can tailor it; defaults match
 * the original "Discard Changes and Leave?" prompt.
 *
 * @param {boolean} show
 * @param {function} onHide - cancel / stay (also the close button)
 * @param {function} onConfirm - discard and leave
 * @param {string} [title]
 * @param {string} [cancelLabel]
 * @param {string} [confirmLabel]
 * @param {React.ReactNode} [children] - body override
 */
const DiscardChangesModal = ({
  show,
  onHide,
  onConfirm,
  title = "Discard Changes and Leave?",
  cancelLabel = "Cancel",
  confirmLabel = "Leave",
  children,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="discard-changes-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-2">
          {children || (
            <>
              <p className="mb-2">You have unsaved changes.</p>
              <p className="mb-0">Do you want to leave without saving?</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>
            {cancelLabel}
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DiscardChangesModal;
